module.exports = __webpack_public_path__ + "assets/img/04a.a5e349f5.jpg";